import { ElMessage } from 'element-plus'
import { useUserStoreWithOut } from '@/store/modules/user'
import { IDLE_STORAGE_KEY } from '@/utils/idleTimeout'

export type AuthFailureReason = 'idle' | 'default'

export type AuthFailureOptions = {
  /** 失效原因；idle 时提示「因长时间无操作，请重新登录」 */
  reason?: AuthFailureReason
}

/** 防止路由守卫 / 请求拦截 / 定时器同时触发多次跳转 */
let handlingAuthFailure = false

/** 登录态失效后清理本地缓存并跳转本系统登录页 */
export const handleAuthFailure = (options?: AuthFailureOptions) => {
  if (handlingAuthFailure) {
    return
  }
  handlingAuthFailure = true

  const reason = options?.reason ?? 'default'
  const pathname = window.location.pathname
  const loginUrl = `/login?redirect=${encodeURIComponent(pathname)}`

  if (reason === 'idle') {
    ElMessage.warning('因长时间无操作，请重新登录')
    clearUserStorage()
    // 稍延迟硬跳转，保证 warning 可见
    setTimeout(() => {
      window.location.href = loginUrl
    }, 1200)
    return
  }

  clearUserStorage()
  window.location.href = loginUrl
}

/** 清除用户相关本地存储 */
export const clearUserStorage = () => {
  try {
    localStorage.removeItem(IDLE_STORAGE_KEY)
    const userStore = useUserStoreWithOut()
    userStore.logout()
  } catch {
    localStorage.removeItem('userInfo')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('isSSO')
    localStorage.removeItem('ssoLogoutUrl')
    localStorage.removeItem(IDLE_STORAGE_KEY)
    sessionStorage.clear()
  }
}
